function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "137.029%",
  y1: "129.104%",
  x2: "50%",
  y2: "50%",
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9F0FF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-160.796%",
  y1: "-224.453%",
  x2: "107.047%",
  y2: "70.702%",
  id: "b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DEF5FE",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-347.113%",
  y1: "338.405%",
  x2: "65.921%",
  y2: "50%",
  id: "c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9F0FF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-97.01%",
  y1: "148.218%",
  x2: "65.921%",
  y2: "50%",
  id: "d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9F0FF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-19.87%",
  y1: "-6.768%",
  x2: "117.594%",
  y2: "100%",
  id: "e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9F0FF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "119.936%",
  y1: "0%",
  x2: "0%",
  y2: "84.589%",
  id: "f"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9F0FF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-89.026%",
  y1: "77.649%",
  x2: "137.149%",
  y2: "17.758%",
  id: "g"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9F0FF",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -20)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "url(#a)",
  transform: "rotate(45 974.87 593.87)",
  x: 955.87,
  y: 574.87,
  width: 38,
  height: 38,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#b)",
  transform: "rotate(45 516.02 369.542)",
  x: 507.521,
  y: 361.042,
  width: 17,
  height: 17,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M1331.962 291.251l12.264 24.528a2 2 0 0 1-1.789 2.894h-24.528a2 2 0 0 1-1.788-2.894l12.264-24.528a2 2 0 0 1 3.577 0z",
  stroke: "url(#c)",
  strokeWidth: 10,
  opacity: 0.543,
  transform: "rotate(30 1330.173 303.173)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M844.672 172.644l18.41 36.82a5 5 0 0 1-4.472 7.236h-36.82a5 5 0 0 1-4.472-7.236l18.41-36.82a5 5 0 0 1 8.944 0z",
  stroke: "url(#d)",
  strokeWidth: 10,
  opacity: 0.543,
  transform: "rotate(30 840.2 190.2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 428c38.952-92.623 95.85-125.954 170.692-99.992 112.265 38.943 152.14 91.606 212.59 0 15.672-23.751 9.865-74.51-29.279-76.526-39.144-2.016-9.251-46.316 58.144-55.007 67.395-8.691-18.096-70.062-69.395-87.898-53.275-18.522 15.159-67.282 20.444-85.903 8.58-30.232-112.485-30.232-363.196 0V428z",
  fill: "url(#e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 738c-87.498-1.025-152.016-21.183-193.555-60.474-62.308-58.935-61.792-186.387-194.636-179.419-132.843 6.968-274.802-21.538-224.4-101.821 50.402-80.284 168.127-70.332 196.264-201.192 28.136-130.86-202.236 27.165-240.286-59.848-14.858-33.98 20.409-38.561-34.273-76.79-18.153-12.69-26.931-31.08-23.312-38.228 1.744-3.445 7.924 1.578 14.37 0 20.466-5.013 63.76 0 107.641 0H1440V738z",
  fill: "url(#f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M520.396 612.23c8.7-1.82 11.409 7.778 27.275 7.778 15.866 0 29.975-9.065 49.61-1.072 19.636 7.994 35.523 32.21 15.406 27.541-11.882-2.758-26.578-11.167-46.816 4.842-20.239 16.008-32.349-14.56-47.511-9.869-15.163 4.692-6.735-27.386 2.036-29.22z",
  fill: "url(#g)"
}));

function SvgBgHeroDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 718,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHeroDesktop);
export default __webpack_public_path__ + "static/media/bg-hero-desktop.6f3681282137997079c4e3826fbb91b4.svg";
export { ForwardRef as ReactComponent };